import { Moment } from 'moment';
import { SimpleSearchFilter } from 'api/dashboard/widget';
import { Sprint } from 'api/sprint-planning/types';
import { Option } from 'components/atoms/select/types';
import { Filter } from 'components/molecules/filters/types';
import { ColumnOrder } from 'components/organisms/grid-custom-column';
import { durationOptions } from './constants';

export enum PageView {
  Sprints = 'sprints',
  Reports = 'reports',
}

export enum Sprints {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}

export enum CreateSprintSectionKeys {
  SprintInfo = 'SprintInfo',
  AdditionalInfo = 'AdditionalInfo',
}

export enum SprintDashboardTabKeys {
  Overview = 'Overview',
  SprintBoard = 'SprintBoard',
}

export type SprintInfoStepFormValues = {
  sprintName: string;
  duration: typeof durationOptions[number];
  startDate: Moment;
  dueDate: Moment;
  owner: { value: number };
  collaborators: { value: number }[];
  isPrivate: boolean;
  sprintType: { value: SprintType };
  projectsSelected: Option[] | Option;
};

export type SprintSettingFormValues = {
  sprintName: string;
  duration: typeof durationOptions[number];
  startDate: Moment;
  dueDate: Moment;
  owner: { value: number };
  sprintCollaborators: { value: number }[];
  projectsSelected: Option[] | Option;
};

export type SprintInfoPayload = Partial<
  Pick<
    Sprint,
    | 'sprintName'
    | 'startDate'
    | 'dueDate'
    | 'sprintOwner'
    | 'fields'
    | 'associatedProjects'
    | 'sprintType'
    | 'sprintCollaborators'
  >
> & { projectPhase?: Sprint['projectPhase'] };

export type AddTaskMutationType = {
  sprintId: number;
  payload: number[];
};

export enum TaskActionType {
  ExistingTask = 1,
  FromPreviousSprint = 2,
  NewTask = 3,
}

export enum MoveTasksType {
  ExistingSprint = 1,
  NewSprint = 2,
}

export enum SprintType {
  SingleProject = 'SINGLE_PROJECT',
  MultipleProjects = 'MULTI_PROJECTS',
  AllProjects = 'ALL_PROJECTS',
}

export const AllProjectsId = 1;

export type SprintGridPayload = {
  sprintId: number;
  payload: SprintUpdatePayload;
};

export type SprintRemoveTaskPayload = {
  sprintId: number;
  payload: { taskIds: number[] };
};

export type CompleteSprintPayload = {
  sprintId: number;
  payload: {
    moveTasks: boolean;
    sprint?:
      | Pick<Sprint, 'sprintId'>
      | Pick<Sprint, 'sprintName' | 'startDate' | 'dueDate'>;
  };
};

export type SprintUpdatePayload = Partial<SprintInfoPayload>;

export interface ApiSprintListViewDefinition {
  filter?: SimpleSearchFilter;
  columnOrder?: ColumnOrder[];
}
export interface SprintListViewDefinition {
  filter: Filter;
  columnOrder?: ColumnOrder[];
}

export enum SprintViews {
  ActiveSprints = -1,
  CompletedSprints = -2,
  AllSprints = -3,
}

export enum SprintDashboardViews {
  Overview = 'overview',
  SprintBoard = 'sprintBoard',
}
